/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Select_Guide_LabelInputs */

const en_knp_lookup_select_guide_label = /** @type {(inputs: Knp_Lookup_Select_Guide_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select KNP Guide`)
};

const fr_knp_lookup_select_guide_label = /** @type {(inputs: Knp_Lookup_Select_Guide_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner un guide KNP`)
};

const de_knp_lookup_select_guide_label = /** @type {(inputs: Knp_Lookup_Select_Guide_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP-Reiseführer auswählen`)
};

const it_knp_lookup_select_guide_label = /** @type {(inputs: Knp_Lookup_Select_Guide_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona la guida KNP`)
};

const ru_knp_lookup_select_guide_label = /** @type {(inputs: Knp_Lookup_Select_Guide_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите путеводитель по КНП`)
};

const es_knp_lookup_select_guide_label = /** @type {(inputs: Knp_Lookup_Select_Guide_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar la Guía KNP`)
};

const zh_cn2_knp_lookup_select_guide_label = /** @type {(inputs: Knp_Lookup_Select_Guide_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择 KNP 指南`)
};

const ja_knp_lookup_select_guide_label = /** @type {(inputs: Knp_Lookup_Select_Guide_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNPガイドを選択`)
};

const hi_knp_lookup_select_guide_label = /** @type {(inputs: Knp_Lookup_Select_Guide_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केएनपी गाइड चुनें`)
};

const pt_pt2_knp_lookup_select_guide_label = /** @type {(inputs: Knp_Lookup_Select_Guide_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o Guia do Parque Nacional Kruger`)
};

/**
* | output |
* | --- |
* | "Select KNP Guide" |
*
* @param {Knp_Lookup_Select_Guide_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_select_guide_label = /** @type {((inputs?: Knp_Lookup_Select_Guide_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Select_Guide_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_select_guide_label(inputs)
	if (locale === "de") return de_knp_lookup_select_guide_label(inputs)
	if (locale === "it") return it_knp_lookup_select_guide_label(inputs)
	if (locale === "ru") return ru_knp_lookup_select_guide_label(inputs)
	if (locale === "es") return es_knp_lookup_select_guide_label(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_select_guide_label(inputs)
	if (locale === "ja") return ja_knp_lookup_select_guide_label(inputs)
	if (locale === "hi") return hi_knp_lookup_select_guide_label(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_select_guide_label(inputs)
	return en_knp_lookup_select_guide_label(inputs)
});